@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1>Certs</h1>
</div>
<p class="lead">
  Each VEN is required to be associated with a TLS 1.2 private key and public cert for encrypted transmissions.
  The public key fingerprint is used to identify the VEN to the VTN.
  <strong>Warning: Deleting or updating a cert for a VEN that is currently registered will cause the registration to be cancelled.</strong>
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createCert" class="btn btn-large btn-primary" (click)="nextPage($event, '/createCert', router)" style="margin-top:9px;">Create Cert</a>
  </div>
}
@if(isLoading) {
  <app-loader
    message="Loading Certs...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Ven ID</th>
      <th>Public Cert Fingerprint</th>
      <th>Secondary Cert Fingerprint</th>
      <th>Last Modified By</th>
      <th></th>
    </tr>
    <!-- Search filter row -->
    <tr>
      <th><input placeholder="VEN ID" class="input-sm form-control" type="search" [(ngModel)]="venIdSearch" (input)="triggerSearch()"/></th>
    </tr>
    </thead>
    <tbody>
      @for(cert of displayedCerts | paginate: paginationModel; track cert) {
        <tr>
          <td>{{cert.ven_id}}</td>
          @if(cert.cert_fingerprint && cert.cert_fingerprint !== "No CA uploaded.") {
            <td>
              <div>{{cert.cert_fingerprint}}</div>
            </td>
          } @else {
            <td></td>
          }
          @if(cert.secondary_cert_fingerprint && cert.secondary_cert_fingerprint !== "No CA uploaded.") {
            <td>
              <div>{{cert.secondary_cert_fingerprint}}</div>
            </td>
          } @else {
            <td></td>
          }
          <td id="updated_by">{{cert.updated_by}}</td>
          @if(isAdmin && isDeletable(cert)) {
            <td><div class="btn-group">
              <a class="btn btn-default" (click)="nextPage(cert.ven_id, '/editCert', router)" id="edit" name="editCert">Edit</a>
              <button class="btn btn-danger" id="delete" type="button" (click)="delete(cert)">Delete</button>
            </div></td>
          }
        </tr>
      }
      @if(displayedCerts.length <= 0) {
        <tr>
          <td colspan="5" style="text-align: center;"> No Certs.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" colspan="18">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
